import { parseISO } from 'date-fns';

export const parsers = {
  /**
   * Parses a string representation of a number into an numeric value
   */
  boolean: () => (value: string) => {
    if (value === 'true') return true;
    if (value === 'false') return false;
    return undefined;
  },
  /**
   * Parses a string representation of a number into an numeric value
   */
  number: () => (value: string) => {
    const trimmed = value.replace(/,/g, '').trim();
    if (!trimmed) return;
    const parsed = Number(trimmed);
    return Number.isFinite(parsed) ? parsed : undefined;
  },
  /**
   * If the date string does not specify a timezone, this
   * will assume THE USERS TIMEZONE
   *
   * eg: 1982-05-11 will parse to 1982-05-11T05:00:00.000Z
   *
   * You may force UTC timezone conversion with the `utc` option.
   */
  date: (options?: { utc?: boolean }) => (value: string) => {
    const parsedDate = new Date(value);
    const maybeDate = Number.isFinite(parsedDate.valueOf()) ? parsedDate : undefined;
    if (maybeDate) {
      const isUTC = maybeDate.getTimezoneOffset() === 0;
      const year = isUTC ? maybeDate.getUTCFullYear() : maybeDate.getFullYear();
      const month = isUTC ? maybeDate.getUTCMonth() : maybeDate.getMonth();
      const day = isUTC ? maybeDate.getUTCDate() : maybeDate.getUTCDate();

      return options?.utc
        ? new Date(
            [
              year.toString().padStart(4, '0'),
              (month + 1).toString().padStart(2, '0'),
              day.toString().padStart(2, '0')
            ].join('-')
          )
        : new Date(year, month, day);
    }
    return undefined;
  },
  dateTime: (options?: { assumeUTC?: boolean }) => (value: string) => {
    // parseISO assumes the user's timezone and new Date() assumes UTC
    const parsedDate = options?.assumeUTC ? new Date(value) : parseISO(value);
    return Number.isFinite(parsedDate.valueOf()) ? parsedDate : undefined;
  },
  string: () => (value: string) => value || undefined,
  stringArray: () => (value: string) => {
    const split = value.split(',');
    return split.length ? split : undefined;
  },
  numberArray: () => (value: string) => {
    const split = value.split(',').flatMap(v => {
      const parsed = Number(v);
      return Number.isFinite(parsed) ? [parsed] : [];
    });
    return split.length ? split : undefined;
  }
};
